"use strict";
exports.__esModule = true;
exports.WalletErrorCodes = exports.Status = exports.Feature = exports.OnboardingStepsVariant = exports.OnboardingStepStatus = exports.OnboardingStep = exports.BusinessLogicExceptionEnum = exports.ProductStatus = exports.decisionEnum = exports.billPaymentInitializerEnum = exports.FlexAnywherePaymentType = exports.CardStatus = exports.BillerType = exports.PaymentRetryWindow = exports.MembershipPeriod = exports.AccountStatus = exports.RepaymentPeriod = exports.settledPaymentStatuses = exports.PaymentCategory = exports.PaymentStatus = exports.ServiceIssueDescription = exports.ServiceIssueCode = exports.BillStatus = exports.AmountStatus = exports.IntegrationType = exports.BillerPropertyStatus = void 0;
var domain_1 = require("@genoa/domain");
exports.BillerPropertyStatus = domain_1.BillerPropertyStatus;
exports.IntegrationType = domain_1.IntegrationType;
var AmountStatus;
(function (AmountStatus) {
    AmountStatus["ESTIMATED"] = "ESTIMATED";
    AmountStatus["CONFIRMED"] = "CONFIRMED";
})(AmountStatus = exports.AmountStatus || (exports.AmountStatus = {}));
var BillStatus;
(function (BillStatus) {
    BillStatus["SCHEDULED"] = "SCHEDULED";
    BillStatus["COVERED"] = "COVERED";
    BillStatus["SERVICE_ISSUE"] = "SERVICE_ISSUE";
    BillStatus["NOT_COVERED"] = "NOT_COVERED";
    BillStatus["PROCESSING"] = "PROCESSING";
})(BillStatus = exports.BillStatus || (exports.BillStatus = {}));
/** @deprecated use ServiceIssueCode in domain/bill */
var ServiceIssueCode;
(function (ServiceIssueCode) {
    ServiceIssueCode["NO_ISSUE"] = "NO_ISSUE";
    ServiceIssueCode["ISSUE_MESSAGING"] = "ISSUE_MESSAGING";
    ServiceIssueCode["BALANCE_TOO_HIGH"] = "BALANCE_TOO_HIGH";
    ServiceIssueCode["BALANCE_TOO_LOW"] = "BALANCE_TOO_LOW";
    ServiceIssueCode["ZERO_BALANCE"] = "ZERO_BALANCE";
    ServiceIssueCode["UPDATE_DEBIT_CARD"] = "UPDATE_DEBIT_CARD";
    ServiceIssueCode["RELINK_PROPERTY"] = "RELINK_PROPERTY";
    ServiceIssueCode["SELF_PAY_DDA"] = "SELF_PAY_DDA";
    ServiceIssueCode["SELF_PAY_VC"] = "SELF_PAY_VC";
    ServiceIssueCode["SELF_PAY_DDA_ISSUED"] = "SELF_PAY_DDA_ISSUED";
    ServiceIssueCode["SELF_PAY_VC_ISSUED"] = "SELF_PAY_VC_ISSUED";
    ServiceIssueCode["SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN"] = "SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN";
    ServiceIssueCode["SELF_PAY_VC_PENDING_BP_WINDOW_OPEN"] = "SELF_PAY_VC_PENDING_BP_WINDOW_OPEN";
    ServiceIssueCode["SELF_PAY_PENDING"] = "SELF_PAY_PENDING";
    ServiceIssueCode["SELF_PAY_OPTED_OUT"] = "SELF_PAY_OPTED_OUT";
    ServiceIssueCode["PAST_DUE_RENT"] = "PAST_DUE_RENT";
    ServiceIssueCode["YARDI_ZERO_BALANCE"] = "YARDI_ZERO_BALANCE";
    ServiceIssueCode["RETRY_OR_UPDATE_CARD"] = "RETRY_OR_UPDATE_CARD";
    ServiceIssueCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    ServiceIssueCode["GENERIC_PAYMENT_FAILURE"] = "GENERIC_PAYMENT_FAILURE";
    ServiceIssueCode["DEFAULT_PAYMENT_FAILURE"] = "DEFAULT_PAYMENT_FAILURE";
    ServiceIssueCode["PAST_DOWNPAYMENT_DEADLINE"] = "PAST_DOWNPAYMENT_DEADLINE";
    ServiceIssueCode["ADDITIONAL_DEPOSIT_NEEDED"] = "ADDITIONAL_DEPOSIT_NEEDED";
    ServiceIssueCode["PORTAL_VALIDATE_CREDENTIALS_FAILURE"] = "PORTAL_VALIDATE_CREDENTIALS_FAILURE";
    ServiceIssueCode["NO_ACTIVE_LEASE"] = "BILLING_NO_ACTIVE_LEASE";
    ServiceIssueCode["INACTIVE_PORTAL"] = "BILLING_INACTIVE_PORTAL";
    ServiceIssueCode["MULTIPLE_ACTIVE_LEASES"] = "BILLING_MULTIPLE_ACTIVE_LEASES";
    ServiceIssueCode["VALID_CREDENTIALS_BUT_2FA_BLOCKED"] = "BILLING_VALID_CREDENTIALS_BUT_2FA_BLOCKED";
    ServiceIssueCode["PORTAL_RESET_PASSWORD_REQUIRED"] = "BILLING_RESET_PASSWORD_REQUIRED";
    ServiceIssueCode["BILLING_API_EXCEPTION"] = "BILLING_API_EXCEPTION";
    ServiceIssueCode["PORTAL_URL_UPDATE_REQUIRED"] = "BILLING_PORTAL_URL_UPDATE_REQUIRED";
    ServiceIssueCode["EARLY_PAY_PAYMENT_REQUIRED"] = "EARLY_PAY_PAYMENT_REQUIRED";
    ServiceIssueCode["FA_SETTLEMENT_PENDING"] = "FA_SETTLEMENT_PENDING";
})(ServiceIssueCode = exports.ServiceIssueCode || (exports.ServiceIssueCode = {}));
var ServiceIssueDescription;
(function (ServiceIssueDescription) {
    ServiceIssueDescription["RELINK"] = "Couldn\u2019t find your rent bill";
    ServiceIssueDescription["SCHEDULED"] = "Flex is scheduled to pay your rent bill";
    ServiceIssueDescription["NOT_COVERED"] = "Couldn\u2019t pay your bill this month";
    ServiceIssueDescription["BALANCE_TOO_LOW"] = "Rent bill is lower than estimate";
    ServiceIssueDescription["BALANCE_TOO_HIGH"] = "Rent bill is higher than estimate";
    ServiceIssueDescription["UPDATE_DEBIT_CARD"] = "1st payment failed";
    ServiceIssueDescription["ISSUE_MESSAGING"] = "Property not accepting payment";
    ServiceIssueDescription["SELF_PAY_DDA"] = "Couldn\u2019t complete bill auto-payment";
    ServiceIssueDescription["SELF_PAY_CONFIRMATION_PENDING"] = "Pending confirmation of Self-Pay";
    ServiceIssueDescription["COVERED"] = "Flex paid your rent bill";
    ServiceIssueDescription["PAST_DUE_RENT"] = "Overdue rent balance";
    ServiceIssueDescription["YARDI_ZERO_BALANCE"] = "No rent balance found";
    ServiceIssueDescription["NOT_COVERED_USER_INITIATED"] = "You\u2019ve opted out of Flex this month";
    ServiceIssueDescription["ADDITIONAL_PAYMENT_REQUIRED"] = "Additional payment required";
    ServiceIssueDescription["PORTAL_CREDENTIALS_RELINK"] = "Portal credentials invalid";
})(ServiceIssueDescription = exports.ServiceIssueDescription || (exports.ServiceIssueDescription = {}));
/**
 * @deprecated Use PaymentStatus from @genoa/domain instead
 */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["SCHEDULED"] = "SCHEDULED";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["AUTHORIZED"] = "AUTHORIZED";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["FUNDED"] = "FUNDED";
    PaymentStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
/**
 * @deprecated Use PaymentCategory from @genoa/domain instead
 */
var PaymentCategory;
(function (PaymentCategory) {
    PaymentCategory["FIRST_PAYMENT"] = "1ST_PAYMENT";
    PaymentCategory["SECOND_PAYMENT"] = "2ND_PAYMENT";
    PaymentCategory["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
    PaymentCategory["ADDITIONAL_DEPOSIT"] = "ADDITIONAL_DEPOSIT";
})(PaymentCategory = exports.PaymentCategory || (exports.PaymentCategory = {}));
exports.settledPaymentStatuses = [PaymentStatus.PAID, PaymentStatus.UNPAID];
var RepaymentPeriod;
(function (RepaymentPeriod) {
    RepaymentPeriod["P0D"] = "P0D";
    RepaymentPeriod["P8D"] = "P8D";
    RepaymentPeriod["P9D"] = "P9D";
    RepaymentPeriod["P10D"] = "P10D";
    RepaymentPeriod["P11D"] = "P11D";
    RepaymentPeriod["P12D"] = "P12D";
    RepaymentPeriod["P13D"] = "P13D";
    RepaymentPeriod["P14D"] = "P14D";
    RepaymentPeriod["P15D"] = "P15D";
    RepaymentPeriod["P16D"] = "P16D";
    RepaymentPeriod["P17D"] = "P17D";
    RepaymentPeriod["P18D"] = "P18D";
    RepaymentPeriod["P19D"] = "P19D";
    RepaymentPeriod["P20D"] = "P20D";
    RepaymentPeriod["P21D"] = "P21D";
    RepaymentPeriod["P22D"] = "P22D";
    RepaymentPeriod["P2W"] = "P2W";
})(RepaymentPeriod = exports.RepaymentPeriod || (exports.RepaymentPeriod = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["DELETED"] = "DELETED";
    AccountStatus["CANCELED"] = "CANCELED";
    AccountStatus["SUSPENDED"] = "SUSPENDED";
    AccountStatus["PAUSED"] = "PAUSED";
    AccountStatus["ROLLOVER"] = "ROLLOVER";
    AccountStatus["DISPUTE"] = "DISPUTE";
    AccountStatus["BLOCKED"] = "BLOCKED";
    AccountStatus["REVOKED"] = "REVOKED";
    AccountStatus["NULL"] = "NULL";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var MembershipPeriod;
(function (MembershipPeriod) {
    MembershipPeriod["P1M"] = "P1M";
})(MembershipPeriod = exports.MembershipPeriod || (exports.MembershipPeriod = {}));
var PaymentRetryWindow;
(function (PaymentRetryWindow) {
    PaymentRetryWindow["TWELVE_TO_FOURTEEN_HOURS"] = "12_TO_14_HOURS";
    PaymentRetryWindow["TWENTY_FOUR_TO_TWENTY_SIX_HOURS"] = "24_TO_26_HOURS";
})(PaymentRetryWindow = exports.PaymentRetryWindow || (exports.PaymentRetryWindow = {}));
/** @deprecated use BillerType in domain/bill*/
var BillerType;
(function (BillerType) {
    BillerType["OUT_OF_NETWORK"] = "OUT_OF_NETWORK";
    BillerType["DIRECT_INTEGRATION"] = "DIRECT_INTEGRATION";
    BillerType["PORTAL"] = "PORTAL";
    BillerType["FLEX_ANYWHERE"] = "FLEX_ANYWHERE";
})(BillerType = exports.BillerType || (exports.BillerType = {}));
var CardStatus;
(function (CardStatus) {
    CardStatus["NOT_READY"] = "NOT_READY";
    CardStatus["READY"] = "READY";
    CardStatus["USED"] = "USED";
})(CardStatus = exports.CardStatus || (exports.CardStatus = {}));
var FlexAnywherePaymentType;
(function (FlexAnywherePaymentType) {
    FlexAnywherePaymentType["VIRTUAL_CARD"] = "VIRTUAL_CARD";
    FlexAnywherePaymentType["DDA"] = "DDA";
})(FlexAnywherePaymentType = exports.FlexAnywherePaymentType || (exports.FlexAnywherePaymentType = {}));
var billPaymentInitializerEnum;
(function (billPaymentInitializerEnum) {
    billPaymentInitializerEnum["AUTOPAY"] = "AUTOPAY";
    billPaymentInitializerEnum["SELFPAY"] = "SELFPAY";
    billPaymentInitializerEnum["EARLYPAY"] = "EARLYPAY";
    billPaymentInitializerEnum["UNKNOWN"] = "UNKNOWN";
})(billPaymentInitializerEnum = exports.billPaymentInitializerEnum || (exports.billPaymentInitializerEnum = {}));
var decisionEnum;
(function (decisionEnum) {
    decisionEnum["APPROVED"] = "APPROVED";
    decisionEnum["PROCEED"] = "PROCEED";
    decisionEnum["REJECTED"] = "REJECTED";
    decisionEnum["NEED_REVIEW"] = "NEED_REVIEW";
})(decisionEnum = exports.decisionEnum || (exports.decisionEnum = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["ACTIVE"] = "ACTIVE";
    ProductStatus["INACTIVE"] = "INACTIVE";
    ProductStatus["CLOSED"] = "CLOSED";
    ProductStatus["PAUSED"] = "PAUSED";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
var BusinessLogicExceptionEnum;
(function (BusinessLogicExceptionEnum) {
    BusinessLogicExceptionEnum["INPUT_ERROR_TOO_HIGH"] = "INPUT_ERROR_TOO_HIGH";
    BusinessLogicExceptionEnum["INPUT_ERROR_TOO_LOW"] = "INPUT_ERROR_TOO_LOW";
    BusinessLogicExceptionEnum["ELIGIBILITY_CHECK_FAILED"] = "ELIGIBILITY_CHECK_FAILED";
    BusinessLogicExceptionEnum["ELIGIBILITY_CHECK_FAILED_CREDIT_FROZEN"] = "ELIGIBILITY_CHECK_FAILED_CREDIT_FROZEN";
    BusinessLogicExceptionEnum["NOT_ALLOWED_AFTER_CUTOFF"] = "NOT_ALLOWED_AFTER_CUTOFF";
    BusinessLogicExceptionEnum["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    BusinessLogicExceptionEnum["INVALID_EMAIL"] = "INVALID_EMAIL";
    BusinessLogicExceptionEnum["INVALID_ZIP_CODE"] = "INVALID_ZIP_CODE";
    BusinessLogicExceptionEnum["VENDOR_RATE_LIMIT_EXCEEDED"] = "VENDOR_RATE_LIMIT_EXCEEDED";
    BusinessLogicExceptionEnum["MUST_RESTART_ONBOARDING"] = "MUST_RESTART_ONBOARDING";
    BusinessLogicExceptionEnum["PREPAY_FAILURE"] = "PREPAY_FAILURE";
    BusinessLogicExceptionEnum["OUTSTANDING_WALLET_BALANCE"] = "OUTSTANDING_WALLET_BALANCE";
    BusinessLogicExceptionEnum["MAX_ATTEMPTS_EXCEEDED"] = "MAX_ATTEMPTS_EXCEEDED";
    BusinessLogicExceptionEnum["MAX_ADD_FUNDS_BALANCE_EXCEEDED"] = "MAX_ADD_FUNDS_BALANCE_EXCEEDED";
    BusinessLogicExceptionEnum["DEFAULT_PAYMENT_METHOD_IS_NOT_DEBIT_CARD"] = "DEFAULT_PAYMENT_METHOD_IS_NOT_DEBIT_CARD";
    BusinessLogicExceptionEnum["USER_ACCOUNT_IS_NOT_ACTIVE"] = "USER_ACCOUNT_IS_NOT_ACTIVE";
    BusinessLogicExceptionEnum["RISK_CHECK_FAILED"] = "RISK_CHECK_FAILED";
    BusinessLogicExceptionEnum["PAYMENT_GENERIC_DECLINE"] = "PAYMENT_GENERIC_DECLINE";
    BusinessLogicExceptionEnum["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    BusinessLogicExceptionEnum["PAYMENT_UPDATE_CARD"] = "PAYMENT_UPDATE_CARD";
    BusinessLogicExceptionEnum["PAYMENT_DEFAULT_FAILURE"] = "PAYMENT_DEFAULT_FAILURE";
})(BusinessLogicExceptionEnum = exports.BusinessLogicExceptionEnum || (exports.BusinessLogicExceptionEnum = {}));
var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["ACCOUNT_CREATION"] = "ACCOUNT_CREATION";
    OnboardingStep["PROPERTY_SELECTION"] = "PROPERTY_SELECTION";
    OnboardingStep["PRODUCT_SELECTION"] = "PRODUCT_SELECTION";
    OnboardingStep["RENT_ESTIMATION"] = "RENT_ESTIMATION";
    OnboardingStep["PAYMENT_METHOD_SETUP"] = "PAYMENT_METHOD_SETUP";
    OnboardingStep["CREDIT_ELIGIBILITY_CHECK"] = "CREDIT_ELIGIBILITY_CHECK";
    OnboardingStep["OFFER_SETUP"] = "OFFER_SETUP";
    OnboardingStep["OFFER_ACCEPT"] = "OFFER_ACCEPT";
    OnboardingStep["REPAYMENT_SCHEDULING"] = "REPAYMENT_SCHEDULING";
    OnboardingStep["CONFIRM_APPROVAL"] = "CONFIRM_APPROVAL";
    OnboardingStep["SETUP_AUTOPILOT"] = "SETUP_AUTOPILOT";
    OnboardingStep["RENT_PROTECT_SETUP"] = "RENT_PROTECT_SETUP";
    OnboardingStep["SELECT_PRODUCT"] = "SELECT_PRODUCT";
    OnboardingStep["VALUE_PROP"] = "VALUE_PROP";
})(OnboardingStep = exports.OnboardingStep || (exports.OnboardingStep = {}));
var OnboardingStepStatus;
(function (OnboardingStepStatus) {
    OnboardingStepStatus["COMPLETE"] = "COMPLETE";
    OnboardingStepStatus["NOT_STARTED"] = "NOT_STARTED";
})(OnboardingStepStatus = exports.OnboardingStepStatus || (exports.OnboardingStepStatus = {}));
var OnboardingStepsVariant;
(function (OnboardingStepsVariant) {
    OnboardingStepsVariant["CONTROL"] = "CONTROL";
    OnboardingStepsVariant["TREATMENT"] = "TREATMENT";
    OnboardingStepsVariant["CREDIT_BUILDER"] = "CREDIT_BUILDER";
    OnboardingStepsVariant["SLC"] = "SLC";
})(OnboardingStepsVariant = exports.OnboardingStepsVariant || (exports.OnboardingStepsVariant = {}));
var Feature;
(function (Feature) {
    Feature["MODIFY_CREDIT_LINE_UTILIZATION"] = "MODIFY_CREDIT_LINE_UTILIZATION";
})(Feature = exports.Feature || (exports.Feature = {}));
var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["INACTIVE"] = "INACTIVE";
})(Status = exports.Status || (exports.Status = {}));
/**
 * @deprecated For legacy hooks only. Use WalletErrorCode enum defined in packages/state-management/src/modules/api/orchestration/types.ts
 * instead
 */
var WalletErrorCodes;
(function (WalletErrorCodes) {
    WalletErrorCodes["W_UNCAUGHT_EXCEPTION"] = "W30000";
    WalletErrorCodes["W_CARD_LINKAGE_THRESHOLD"] = "W30001";
    WalletErrorCodes["W_BLOCK_CAPITAL_ONE"] = "W30002";
    WalletErrorCodes["W_ADD_FUNDS_INVALID_AMOUNT"] = "W30004";
    WalletErrorCodes["W_ADD_FUNDS_TOS"] = "W30005";
    WalletErrorCodes["W_ADD_FUNDS_MAX_ATTEMPTS_EXCEEDED"] = "W30006";
    WalletErrorCodes["W_ADD_FUNDS_MAX_BALANCE_EXCEEDED"] = "W30007";
    WalletErrorCodes["W_ADD_FUNDS_DEBIT_CARD_REQUIRED"] = "W30008";
    WalletErrorCodes["W_ADD_FUNDS_INACTIVE_ACCOUNT"] = "W30009";
    WalletErrorCodes["W_WITHDRAW_FUNDS_INVALID_AMOUNT"] = "W30010";
    WalletErrorCodes["W_WITHDRAW_DEBIT_CARD_REQUIRED"] = "W30011";
    WalletErrorCodes["W_WITHDRAW_PAYMENT_METHOD_ADDED_WITHIN_24_HOURS"] = "W30012";
    WalletErrorCodes["W_WITHDRAW_FUNDS_MAX_COUNTED_EXCEEDED"] = "W30013";
})(WalletErrorCodes = exports.WalletErrorCodes || (exports.WalletErrorCodes = {}));
